import LegalPage from "@/pages/LegalPage";
export default function CookiePolicy() {
  return <LegalPage tKey="cookie" testId="cookie-policy-page" />;
}
